import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import Select from "./elements/Select"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-act-btn ns-act-btn-light ns-filters ns-d-inline-flex ns-text-align-center ns-align-items-center ${className} ns-py-2 ns-px-0`}
        >
            {/* <Icon name="filter" /> */}
            <svg style="width: 2rem;" class="icon icon-filter" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" d="M4.833 6.5a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0ZM4.05 7H2.5a.5.5 0 0 1 0-1h1.55a2.5 2.5 0 0 1 4.9 0h8.55a.5.5 0 0 1 0 1H8.95a2.5 2.5 0 0 1-4.9 0Zm11.117 6.5a1.667 1.667 0 1 0-3.334 0 1.667 1.667 0 0 0 3.334 0ZM13.5 11a2.5 2.5 0 0 1 2.45 2h1.55a.5.5 0 0 1 0 1h-1.55a2.5 2.5 0 0 1-4.9 0H2.5a.5.5 0 0 1 0-1h8.55a2.5 2.5 0 0 1 2.45-2Z" fill="currentColor"></path>
            </svg>
            <span style="margin-left: 10px;" class="ns-font-4 ns-nowrap">Filter and sort</span>
            {/* {selectedFiltersCount > 0 && (
                <span className="ns-total-count ns-d-inline-block ns-text-align-center ns-font-3 ns-font-bold ns-color-white ns-background-primary ns-ml-1">
                    {selectedFiltersCount}
                </span>
            )} */}
        </label>
    )
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppState()
    
    const selectedFiltersCount = useSelectedFiltersCount()

    const docCount = response.products?.total ?? 0

    // '${query.query}' -
    const totalSummary = pageType === "category" ? `${docCount} products` : `${docCount} results`

    

    return (
        <div
        // ns-flex-wrap
            class="ns-header-controls ns-d-flex ns-flex-row ns-d-none ns-d-md-flex ns-align-items-center ns-justify-content-between"
            // style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
                
            </div>
            {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-d-md-block ns-align-self-md-center ns-total-results ns-font-3"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </span>
            )}
        </div>
    )
}
